import axios from '../axios'
// 查询用户列表
export const getUserList = (data) => {
    return axios({
      url: '/con/account/listUser',
      method: 'POST',
      data: data
    })
}
export const createUser = (data) => {
  return axios({
    url: '/con/account/createUser',
    method: 'POST',
    data: data
  })
}
export const updateUser = (data) => {
  return axios({
    url: '/con/account/updateUser',
    method: 'POST',
    data: data
  })
}
export const exportUser = (data) => {
  return axios({
    url: '/con/account/exportUser',
    method: 'POST',
    data: data
  })
}
export const listHomeworkClass = (data) => {
  return axios({
    url: '/con/class/listHomeworkClass',
    method: 'POST',
    data: data
  })
}
export const 	create = (data) => {
  return axios({
    url: '/con/class/create',
    method: 'POST',
    data: data
  })
}
export const 	update = (data) => {
  return axios({
    url: '/con/class/update',
    method: 'POST',
    data: data
  })
}
export const 	listHomeworkStudentClass = (data) => {
  return axios({
    url: '/con/student/class/listHomeworkStudentClass',
    method: 'POST',
    data: data
  })
}
export const 	removeStudentClass = (data) => {
  return axios({
    url: '/con/student/class/removeStudentClass',
    method: 'POST',
    data: data
  })
}
export const 	add = (data) => {
  return axios({
    url: '/con/student/class/add',
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/user.js